import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { SimpleImage, Typography } from "@parkschannel/ui";
export const BecomeCreatorCover = ()=>{
    return /*#__PURE__*/ _jsxs("section", {
        className: "relative bg-neutral-200 w-full h-[460px] rounded-2xl overflow-hidden lg:h-[635px]",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute top-0 left-0 w-full h-full",
                children: [
                    /*#__PURE__*/ _jsx(SimpleImage, {
                        src: "/media/for-creators.jpg",
                        alt: "Become creator page cover",
                        fill: true,
                        className: "object-cover"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/20 to-black/50"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "p-6 w-full h-full relative bg-transparent flex items-end md:px-10 md:py-[30px] lg:px-[116px] lg:pb-[102px]",
                children: /*#__PURE__*/ _jsxs("article", {
                    className: "max-w-[521px] lg:max-w-[775px]",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h1",
                            className: "line-clamp-3 text-white mb-2 md:text-[40px] md:leading-[44px] lg:mb-3",
                            children: "Share your videos and earn a chance to win a prize!"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "bodyXL",
                            className: "line-clamp-3 text-white ",
                            children: "Entertain. Inform. And win Parks Channel swag. The best videos will earn t-shirts and other cool items."
                        })
                    ]
                })
            })
        ]
    });
};
